import React, { FC, useCallback, useEffect, useState, useContext } from 'react'
import { cn } from 'shared/utils'

import StepItem from './StepItem'
import { EnvContext } from 'modulesCommon/EnvProvider'

import { IStepperProps, TStep } from './Stepper.props'

import styles from './Stepper.module.scss'

const Stepper: FC<IStepperProps> = ({ children, stepsInfo, activeStep, setActiveStep, className }) => {
  const [currentStep, setCurrentStep] = useState<number>(activeStep || 0)
  const { primaryColor } = useContext(EnvContext)

  const onStepClick = useCallback(
    (step: number) => () => {
      setCurrentStep(step)
      setActiveStep && setActiveStep(step)
    },
    [setActiveStep]
  )

  useEffect(() => {
    setCurrentStep(activeStep)
  }, [activeStep])

  return (
    <div className={styles.stepperContainer}>
      <header className={cn(styles.stepper, className, primaryColor)}>
        {stepsInfo.map((step: TStep, index: number) => (
          <React.Fragment key={step.name}>
            <StepItem
              index={index + 1}
              step={step}
              disabled={currentStep < index}
              completed={currentStep > index}
              active={currentStep === index}
              isLastStep={index + 1 === stepsInfo.length}
              onClick={onStepClick(index)}
              className={primaryColor}
            />
          </React.Fragment>
        ))}
      </header>
      <div className={styles.stepperContent}>{children}</div>
    </div>
  )
}

export default Stepper
